import GlobalComponentsWrapper from "./GlobalComponentsWrapper";
import { GrowthBookProvider, GrowthBook } from "@growthbook/growthbook-react";
import config from "@Config/index";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import "./global.scss";
import ClientOnlyLanguageGuard from "@Components/ClientOnlyLanguageGuard";
import { PostHogProvider } from "@Utils/posthog";

interface Props {
  children: any;
}

const growthbook = new GrowthBook({
  apiHost: config.growthbook.apiHost,
  clientKey: config.growthbook.clientKey,
  enableDevMode: !config.isProduction,
  subscribeToChanges: true,
  backgroundSync: true,
  trackingCallback: (experiment, result) => {
    gtagEventEmitter({
      action: "experiment_viewed",
      category: "",
      experiment_id: experiment.key,
      variation_id: result.key,
    });
  },
});

export const DesktopLayout = (props: Props) => {
  const { children } = props;

  const content = (
    <>
      <div id="forPortal" />
      <GrowthBookProvider growthbook={growthbook}>
        <GlobalComponentsWrapper growthbook={growthbook} />
        {config.IS_CHINA_APP ? (
          children
        ) : (
          <ClientOnlyLanguageGuard>{children}</ClientOnlyLanguageGuard>
        )}
      </GrowthBookProvider>
    </>
  );

  return <PostHogProvider>{content}</PostHogProvider>;
};

const Layout = (props: Props) => {
  const { children } = props;

  const content = (
    <>
      <div id="forPortal" />
      <GrowthBookProvider growthbook={growthbook}>
        {config.IS_CHINA_APP ? (
          children
        ) : (
          <ClientOnlyLanguageGuard>{children}</ClientOnlyLanguageGuard>
        )}
        <GlobalComponentsWrapper growthbook={growthbook} />
      </GrowthBookProvider>
    </>
  );

  return <PostHogProvider>{content}</PostHogProvider>;
};

export default Layout;
